const CUSTOMER_EXISTING = "existingCustomer";
const CUSTOMER_NEW = "newCustomer";
const CUSTOMER_SIGNUP = "signupCustomer";
const EMAIL = "email";
const PASSWORD = "password";
const EXISTING_PASSWORD = "existing_password";
const COMPANY_NAME = "company";
const CONTACT_NAME = "name";
const PHONE = "phone";
const STREET_ADDRESS = "address1";
const CITY = "city";
const STATE = "state";
const ZIP_CODE = "zip";
const WORKING_WITH_USPS_REP = "working_with_usps_rep";
const HOW_DID_YOU_HEAR_ABOUT_US = "how_did_you_hear_about_us";
const USPS_REPRESENTATIVE = "salesrep";
const EXISTING_CUSTOMER = "existing_customer";
const AGREED_TO_TERMS = "agreedToTerms";
const SUBSCRIBED_TO_MARKETING = "subscribedToMarketing";
const SALES_REP_ASSIGNEMENT_CONSENT = "salesRepAssignmentConsent";

export {
    CUSTOMER_EXISTING,
    CUSTOMER_NEW,
    CUSTOMER_SIGNUP,
    EMAIL,
    PASSWORD,
    EXISTING_PASSWORD,
    COMPANY_NAME,
    CONTACT_NAME,
    PHONE,
    STREET_ADDRESS,
    CITY,
    STATE,
    ZIP_CODE,
    WORKING_WITH_USPS_REP,
    HOW_DID_YOU_HEAR_ABOUT_US,
    USPS_REPRESENTATIVE,
    EXISTING_CUSTOMER,
    AGREED_TO_TERMS,
    SUBSCRIBED_TO_MARKETING,
    SALES_REP_ASSIGNEMENT_CONSENT,
};
